import React, { useState } from 'react';
import { Shield } from 'lucide-react';

// Drop your own licensed coat-of-arms graphics into /public/assets/wappen/<id>.png
const regions = [
  { id: 'schleswig-holstein', name: 'Schleswig-Holstein' },
  { id: 'hamburg', name: 'Hamburg' },
  { id: 'bayern', name: 'Bayern' },
];

function Wappen({ id, name }) {
  const [missing, setMissing] = useState(false);
  if (missing) {
    return (
      <div className="w-16 h-[76px] md:w-20 md:h-[92px] rounded-b-[40%] rounded-t-md border-2 border-dashed border-[#E0A72C]/70 bg-white/5 flex flex-col items-center justify-center text-[#E8B547]" data-testid={`wappen-placeholder-${id}`}>
        <Shield className="w-6 h-6 md:w-7 md:h-7" />
        <span className="mt-1 text-[9px] uppercase tracking-wider font-bold">Wappen</span>
      </div>
    );
  }
  return <img src={`/assets/wappen/${id}.png`} alt={`Wappen ${name}`} onError={() => setMissing(true)} className="h-[76px] md:h-[92px] w-auto object-contain drop-shadow-[0_6px_16px_rgba(0,0,0,0.45)]" data-testid={`wappen-${id}`} />;
}

export default function RegionBadges() {
  return (
    <section className="relative bg-[#081533] border-y border-white/10" data-testid="region-badges">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 md:py-10 grid md:grid-cols-[auto_1fr] items-center gap-6 md:gap-12">
        <div className="max-w-xs">
          <span className="crown-divider text-[#E0A72C]">Vor Ort für Sie</span>
          <h2 className="mt-2 text-white font-extrabold text-base md:text-lg leading-snug">Zuhause in drei Bundesländern – deutschlandweit nach Absprache.</h2>
        </div>
        <div className="flex flex-wrap justify-center md:justify-end gap-8 md:gap-14">
          {regions.map((r) => (
            <div key={r.id} className="flex flex-col items-center gap-3 text-center min-w-[120px]">
              <Wappen id={r.id} name={r.name} />
              <div className="text-white font-bold text-sm md:text-base whitespace-nowrap">{r.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
